module.exports = __webpack_public_path__ + "static/media/chevron-red.00976248.svg";